import { render, staticRenderFns } from "./PreviewCardCurriculumAlignment.vue?vue&type=template&id=6ea5a519&scoped=true&"
import script from "./PreviewCardCurriculumAlignment.vue?vue&type=script&lang=js&"
export * from "./PreviewCardCurriculumAlignment.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCardCurriculumAlignment.vue?vue&type=style&index=0&id=6ea5a519&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea5a519",
  null
  
)

export default component.exports